import { type ReferentialEnum, labelOf } from "@pharmupp/p3-front-commons"

// Define the columns used in the affiliation CSV import. The order of columns matters.
export const adhAffiliationColumns = ["cipCode", "userEmail"] as const

export type AdhAffiliationColumnName = (typeof adhAffiliationColumns)[number]

const adhAffiliationColumnsEnum = {
  cipCode: { label: "Code CIP" },
  userEmail: { label: "Adresse e-mail" },
} satisfies Record<AdhAffiliationColumnName, unknown> & ReferentialEnum

export const adhAffiliationLabels = adhAffiliationColumns.map((key) =>
  labelOf(adhAffiliationColumnsEnum, key),
)
